import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <nav id="id_bloc" className="navbar navbar-expand-md fixed-top shadow-sm" style="display: flex; flex-direction: column; padding: 0;">
                    {/* SVG Defs pour Bootstrap Icons */}
                    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <defs>
                            <symbol id="icon-list" viewbox="0 0 16 16">
                                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"></path>
                            </symbol>
                            <symbol id="icon-x-lg" viewbox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"></path>
                            </symbol>
                        </defs>
                    </svg>
                    {/* id_overhead - Ligne du haut */}
                    <div className="d-none d-sm-flex justify-content-between w-100">
                        {/* id_overhead_texte_gauche */}
                        <a href="attribut_id_overhead_texte_gauche_lien" id="id_overhead_texte_gauche">
{id_overheadTexte}_gauche_texte
                        </a>
                        {/* end-id_overhead_texte_gauche */}
                        {/* id_overhead_texte_droite */}
                        <a href="attribut_id_overhead_texte_droite_lien" id="id_overhead_texte_droite">
{id_overheadTexte}_droite_texte
                        </a>
                        {/* end-id_overhead_texte_droite */}
                    </div>
                    {/* end-id_overhead */}
                    {/* id_head - Menu principal */}
                    <div className="container-fluid position-relative d-flex justify-content-start align-items-center">
                        {/* Bouton toggle pour mobile */}
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                            <svg className="navbar-icon" width="24" height="24" fill="currentColor">
                                <use href="#icon-list"></use>
                            </svg>
                        </button>
                        {/* Contenu collapsible */}
                        <div className="collapse navbar-collapse justify-content-center" id="navbarContent">
                            <div id="navFlexWrapper">
                                {/* id_head_lien_surlignage_1 */}
                                <a href="attribut_id_head_lien_surlignage_1_lien" id="id_head_lien_surlignage_1" className="nav-link-header">
                                    {/* id_head_lien_surlignage_1_texte_1 */}
                                    <span id="id_head_lien_surlignage_1_texte_1">
attribut_id_head_lien_surlignage_1_texte_1_texte
                                    </span>
                                    {/* end-id_head_lien_surlignage_1_texte_1 */}
                                </a>
                                {/* end-id_head_lien_surlignage_1 */}
                                {/* id_head_lien_surlignage_2 */}
                                <a href="attribut_id_head_lien_surlignage_2_lien" id="id_head_lien_surlignage_2" className="nav-link-header">
                                    {/* id_head_lien_surlignage_2_texte_1 */}
                                    <span id="id_head_lien_surlignage_2_texte_1">
attribut_id_head_lien_surlignage_2_texte_1_texte
                                    </span>
                                    {/* end-id_head_lien_surlignage_2_texte_1 */}
                                </a>
                                {/* end-id_head_lien_surlignage_2 */}
                                {/* id_head_lien_surlignage_3 */}
                                <a href="attribut_id_head_lien_surlignage_3_lien" id="id_head_lien_surlignage_3" className="nav-link-header">
                                    {/* id_head_lien_surlignage_3_texte_1 */}
                                    <span id="id_head_lien_surlignage_3_texte_1">
attribut_id_head_lien_surlignage_3_texte_1_texte
                                    </span>
                                    {/* end-id_head_lien_surlignage_3_texte_1 */}
                                </a>
                                {/* end-id_head_lien_surlignage_3 */}
                                {/* id_head_lien_dropdown_1 */}
                                <div id="id_head_lien_dropdown_1" className="dropdown">
                                    {/* id_head_lien_dropdown_1_lien_simple */}
                                    <a href="attribut_id_head_lien_dropdown_1_lien_simple_lien" id="id_head_lien_dropdown_1_lien_simple" className="dropdown-toggle nav-link-header" data-bs-toggle="dropdown" aria-expanded="false">
                                        {/* id_head_lien_dropdown_1_lien_simple_texte_1 */}
                                        <span id="id_head_lien_dropdown_1_lien_simple_texte_1">
attribut_id_head_lien_dropdown_1_lien_simple_texte_1_texte
                                        </span>
                                        {/* end-id_head_lien_dropdown_1_lien_simple_texte_1 */}
                                    </a>
                                    {/* end-id_head_lien_dropdown_1_lien_simple */}
                                    {/* id_head_lien_dropdown_1_dropdown_box */}
                                    <div id="id_head_lien_dropdown_1_dropdown_box" className="dropdown-menu">
                                        {/* Contenu de la dropdown box ici */}
                                    </div>
                                    {/* end-id_head_lien_dropdown_1_dropdown_box */}
                                </div>
                                {/* end-id_head_lien_dropdown_1 */}
                                {/* id_head_lien_dropdown_2 */}
                                <div id="id_head_lien_dropdown_2" className="dropdown">
                                    {/* id_head_lien_dropdown_2_lien_simple */}
                                    <a href="attribut_id_head_lien_dropdown_2_lien_simple_lien" id="id_head_lien_dropdown_2_lien_simple" className="dropdown-toggle nav-link-header" data-bs-toggle="dropdown" aria-expanded="false">
                                        {/* id_head_lien_dropdown_2_lien_simple_texte_1 */}
                                        <span id="id_head_lien_dropdown_2_lien_simple_texte_1">
attribut_id_head_lien_dropdown_2_lien_simple_texte_1_texte
                                        </span>
                                        {/* end-id_head_lien_dropdown_2_lien_simple_texte_1 */}
                                    </a>
                                    {/* end-id_head_lien_dropdown_2_lien_simple */}
                                    {/* id_head_lien_dropdown_2_dropdown_box */}
                                    <div id="id_head_lien_dropdown_2_dropdown_box" className="dropdown-menu">
                                        {/* Contenu de la dropdown box ici */}
                                    </div>
                                    {/* end-id_head_lien_dropdown_2_dropdown_box */}
                                </div>
                                {/* end-id_head_lien_dropdown_2 */}
                                {/* id_head_lien_dropdown_3 */}
                                <div id="id_head_lien_dropdown_3" className="dropdown">
                                    {/* id_head_lien_dropdown_3_lien_simple */}
                                    <a href="attribut_id_head_lien_dropdown_3_lien_simple_lien" id="id_head_lien_dropdown_3_lien_simple" className="dropdown-toggle nav-link-header" data-bs-toggle="dropdown" aria-expanded="false">
                                        {/* id_head_lien_dropdown_3_lien_simple_texte_1 */}
                                        <span id="id_head_lien_dropdown_3_lien_simple_texte_1">
attribut_id_head_lien_dropdown_3_lien_simple_texte_1_texte
                                        </span>
                                        {/* end-id_head_lien_dropdown_3_lien_simple_texte_1 */}
                                    </a>
                                    {/* end-id_head_lien_dropdown_3_lien_simple */}
                                    {/* id_head_lien_dropdown_3_dropdown_box */}
                                    <div id="id_head_lien_dropdown_3_dropdown_box" className="dropdown-menu">
                                        {/* Contenu de la dropdown box ici */}
                                    </div>
                                    {/* end-id_head_lien_dropdown_3_dropdown_box */}
                                </div>
                                {/* end-id_head_lien_dropdown_3 */}
                                {/* id_head_lien_surlignage_4 */}
                                <a href="attribut_id_head_lien_surlignage_4_lien" id="id_head_lien_surlignage_4" className="nav-link-header">
                                    {/* id_head_lien_surlignage_4_texte_1 */}
                                    <span id="id_head_lien_surlignage_4_texte_1">
attribut_id_head_lien_surlignage_4_texte_1_texte
                                    </span>
                                    {/* end-id_head_lien_surlignage_4_texte_1 */}
                                </a>
                                {/* end-id_head_lien_surlignage_4 */}
                                {/* id_head_lien_surlignage_5 */}
                                <a href="attribut_id_head_lien_surlignage_5_lien" id="id_head_lien_surlignage_5" className="nav-link-header">
                                    {/* id_head_lien_surlignage_5_texte_1 */}
                                    <span id="id_head_lien_surlignage_5_texte_1">
attribut_id_head_lien_surlignage_5_texte_1_texte
                                    </span>
                                    {/* end-id_head_lien_surlignage_5_texte_1 */}
                                </a>
                                {/* end-id_head_lien_surlignage_5 */}
                                {/* id_head_lien_surlignage_6 */}
                                <a href="attribut_id_head_lien_surlignage_6_lien" id="id_head_lien_surlignage_6" className="nav-link-header">
                                    {/* id_head_lien_surlignage_6_texte_1 */}
                                    <span id="id_head_lien_surlignage_6_texte_1">
attribut_id_head_lien_surlignage_6_texte_1_texte
                                    </span>
                                    {/* end-id_head_lien_surlignage_6_texte_1 */}
                                </a>
                                {/* end-id_head_lien_surlignage_6 */}
                                {/* id_head_lien_dropdown_4 */}
                                <div id="id_head_lien_dropdown_4" className="dropdown">
                                    {/* id_head_lien_dropdown_4_lien_simple */}
                                    <a href="attribut_id_head_lien_dropdown_4_lien_simple_lien" id="id_head_lien_dropdown_4_lien_simple" className="dropdown-toggle nav-link-header" data-bs-toggle="dropdown" aria-expanded="false">
                                        {/* id_head_lien_dropdown_4_lien_simple_texte_1 */}
                                        <span id="id_head_lien_dropdown_4_lien_simple_texte_1">
attribut_id_head_lien_dropdown_4_lien_simple_texte_1_texte
                                        </span>
                                        {/* end-id_head_lien_dropdown_4_lien_simple_texte_1 */}
                                    </a>
                                    {/* end-id_head_lien_dropdown_4_lien_simple */}
                                    {/* id_head_lien_dropdown_4_dropdown_box */}
                                    <div id="id_head_lien_dropdown_4_dropdown_box" className="dropdown-menu">
                                        {/* Contenu de la dropdown box ici */}
                                    </div>
                                    {/* end-id_head_lien_dropdown_4_dropdown_box */}
                                </div>
                                {/* end-id_head_lien_dropdown_4 */}
                                {/* id_head_lien_dropdown_5 */}
                                <div id="id_head_lien_dropdown_5" className="dropdown">
                                    {/* id_head_lien_dropdown_5_lien_simple */}
                                    <a href="attribut_id_head_lien_dropdown_5_lien_simple_lien" id="id_head_lien_dropdown_5_lien_simple" className="dropdown-toggle nav-link-header" data-bs-toggle="dropdown" aria-expanded="false">
                                        {/* id_head_lien_dropdown_5_lien_simple_texte_1 */}
                                        <span id="id_head_lien_dropdown_5_lien_simple_texte_1">
attribut_id_head_lien_dropdown_5_lien_simple_texte_1_texte
                                        </span>
                                        {/* end-id_head_lien_dropdown_5_lien_simple_texte_1 */}
                                    </a>
                                    {/* end-id_head_lien_dropdown_5_lien_simple */}
                                    {/* id_head_lien_dropdown_5_dropdown_box */}
                                    <div id="id_head_lien_dropdown_5_dropdown_box" className="dropdown-menu">
                                        {/* Contenu de la dropdown box ici */}
                                    </div>
                                    {/* end-id_head_lien_dropdown_5_dropdown_box */}
                                </div>
                                {/* end-id_head_lien_dropdown_5 */}
                                {/* id_head_lien_dropdown_6 */}
                                <div id="id_head_lien_dropdown_6" className="dropdown">
                                    {/* id_head_lien_dropdown_6_lien_simple */}
                                    <a href="attribut_id_head_lien_dropdown_6_lien_simple_lien" id="id_head_lien_dropdown_6_lien_simple" className="dropdown-toggle nav-link-header" data-bs-toggle="dropdown" aria-expanded="false">
                                        {/* id_head_lien_dropdown_6_lien_simple_texte_1 */}
                                        <span id="id_head_lien_dropdown_6_lien_simple_texte_1">
attribut_id_head_lien_dropdown_6_lien_simple_texte_1_texte
                                        </span>
                                        {/* end-id_head_lien_dropdown_6_lien_simple_texte_1 */}
                                    </a>
                                    {/* end-id_head_lien_dropdown_6_lien_simple */}
                                    {/* id_head_lien_dropdown_6_dropdown_box */}
                                    <div id="id_head_lien_dropdown_6_dropdown_box" className="dropdown-menu">
                                        {/* Contenu de la dropdown box ici */}
                                    </div>
                                    {/* end-id_head_lien_dropdown_6_dropdown_box */}
                                </div>
                                {/* end-id_head_lien_dropdown_6 */}
                            </div>
                        </div>
                        {/* id_head_bouton_1 - Positionné à droite en absolu */}
                        <div className="btn-group-right d-none d-md-flex">
                            <a href="attribut_id_head_bouton_1_lien" id="id_head_bouton_1" className="btn" role="button">
                                {/* id_head_bouton_1_texte_1 */}
                                <span id="id_head_bouton_1_texte_1">
attribut_id_head_bouton_1_texte_1_texte
                                </span>
                                {/* end-id_head_bouton_1_texte_1 */}
                            </a>
                        </div>
                        {/* end-id_head_bouton_1 */}
                    </div>
                    {/* end-id_head */}
                    {/* id_underhead - Ligne du bas avec liens dropdown */}
                    <div className="d-none d-md-flex justify-content-start w-100">
                        {/* id_underhead_dropdown_{n} */}
                        <div id="id_underhead_dropdown_{n}" className="dropdown">
                            {/* id_underhead_dropdown_{n}_titre */}
                            <a href="#" id="id_underhead_dropdown_{n}_titre" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                {/* id_underhead_dropdown_{n}_titre_texte */}
                                <span id="id_underhead_dropdown_{n}_titre_texte">
attribut_id_underhead_dropdown_{n}_titre_texte_texte
                                </span>
                                {/* end-id_underhead_dropdown_{n}_titre_texte */}
                            </a>
                            {/* end-id_underhead_dropdown_{n}_titre */}
                            {/* id_underhead_dropdown_{n}_box */}
                            <ul id="id_underhead_dropdown_{n}_box" className="dropdown-menu">
                                {/* id_underhead_dropdown_{n}_line_1 */}
                                <li id="id_underhead_dropdown_{n}_line_1"></li>
                                {/* end-id_underhead_dropdown_{n}_line_1 */}
                                {/* id_underhead_dropdown_{n}_lien_{n2} */}
                                <li>
                                    <a id="id_underhead_dropdown_{n}_lien_{n2}" className="dropdown-item" href="attribut_id_underhead_dropdown_{n}_lien_{n2}_lien">
                                        {/* id_underhead_dropdown_{n}_lien_{n2}_texte */}
                                        <span id="id_underhead_dropdown_{n}_lien_{n2}_texte">
attribut_id_underhead_dropdown_{n}_lien_{n2}_texte_texte
                                        </span>
                                        {/* end-id_underhead_dropdown_{n}_lien_{n2}_texte */}
                                    </a>
                                </li>
                                {/* end-id_underhead_dropdown_{n}_lien_{n2} */}
                            </ul>
                            {/* end-id_underhead_dropdown_{n}_box */}
                        </div>
                        {/* end-id_underhead_dropdown_{n} */}
                        {/* end-id_underhead */}
                    </div>
                </nav>
                {/* end-id_bloc */}
            </section>
        </>
    );
}